import { Box } from '@mui/material';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { MaritimeDestinationInfo, OrderInfo } from 'adoms-common-lib';
import React from 'react';
import InfoRow from '../atoms/InfoRow';

type MaritimeOrderDestinationInfoProps = {
    order: OrderInfo | undefined,
};

/**
 * 受け取り人情報を表示する
 * @param props order
 */
export const MaritimeOrderDestinationInfo: React.FC<MaritimeOrderDestinationInfoProps> = (props) => {
    const order = props.order as OrderInfo;
    const maritimeDestinationInfo = order.destination as MaritimeDestinationInfo;

    const displayValue = (value: string | undefined) => (value && value !== '' ? value : 'ー');
    const unit = maritimeDestinationInfo?.transportRequestUnit;
    return (
        <Paper sx={{
            textAlign: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
        }} elevation={0}>
            <Typography variant="subtitle1" textAlign="left" color="primary" fontWeight="bold" sx={{ mb: 1 }}>
                輸送依頼部隊
            </Typography>
            <Box sx={{ textAlign: 'left' }}>
                <InfoRow label="部隊名" value={displayValue(unit?.unitName)} />
                <InfoRow label="担当者" value={`${displayValue(unit?.lastname)} ${displayValue(unit?.firstname)}様`} />
                <InfoRow label="メールアドレス" value={displayValue(unit?.mailaddress)} />
                <InfoRow label="電話番号" value={displayValue(unit?.tel)} />
            </Box>
        </Paper>
    );

}